import React from "react";
import { Title } from "../../../../../../stories/Title/Title";
import SuccessGif from "../../../../../../images/Quotation_Submitted.gif"
const Success = () => {
  return (
    <>
      <div className="review-quotation__success">
        <div className="review-quotation__success--block">
          <Title>Successfully Quotation Submitted</Title>
          <div className="review-quotation__success--block--image">
            <img src={SuccessGif} alt="" />
          </div>
          <p className="review-quotation__success--block--text">
            Your quotation has been submitted Successfully! We'll notify you
            with an order confirmation as soon as Possible. Stay connected!
          </p>
        </div>
      </div>
    </>
  );
};

export default Success;
